<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <h1 class="text-center">AUGMENTED REALITY</h1>
            </div>

            <div v-for="(game, gameIndex) in games" :key="gameIndex" class="animation col-xs-12">
                <!-- Carousel container -->
                <div :id="`my-pics${gameIndex}`" class="carousel slide" data-ride="carousel">
                    <!-- Indicators -->
                    <ol v-if="game.totalImages > 1" class="carousel-indicators">
                        <li v-for="(number, imageIndex) in game.totalImages" :key="imageIndex" :data-target="`#my-pics${gameIndex}`" :data-slide-to="imageIndex"
                            :class="{ active: imageIndex == 0 }"></li>
                    </ol>

                    <!-- Content -->
                    <div class="carousel-inner" role="listbox">
                        <!-- Slides -->
                        <div v-for="(number, imageIndex) in game.totalImages" :key="imageIndex" class="item" :class="{ active: imageIndex == 0 }">
                            <img :src="require(`@/assets/gallery/ar/${game.imageFolder}/${number}.png`)" alt="" />
                        </div>
                    </div>

                    <!-- Previous/Next controls -->
                    <template v-if="game.totalImages > 1">
                        <a class="left carousel-control" :href="`#my-pics${gameIndex}`" role="button" data-slide="prev">
                            <span class="icon-prev" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="right carousel-control" :href="`#my-pics${gameIndex}`" role="button" data-slide="next">
                            <span class="icon-next" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </template>
                </div>
                <div class="desc">
                    <h2>{{ game.title }}</h2>
                    <p v-html="game.desc"></p>
                    <a v-if="game.downloadLink" class="btn btn-default download-btn" :href="game.downloadLink" target="_blank" role="button">Store page</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    //Slide show (bootstrap 3 carousel) link:
    //https://www.quackit.com/bootstrap/bootstrap_3/tutorial/bootstrap_carousel.cfm
    data(){
        return {
            games: [
                {
                    title: 'AR ball',
                    desc: 
                        `This is an AR application made in Unity for Android devices. 
                        It detects surfaces and by touching the screen of the phone 
                        a 3D ball will be placed.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'ar-ball',
                        totalImages: 1,
                        downloadLink: null,
                },
                {
                    title: 'Augmented Reality app',
                    desc: 
                        `AR application which detects surfaces and by touching 
                        the screen of the phone a random 3D object will be 
                        placed - made for Android devices.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'ar-app',
                        totalImages: 2,   
                        downloadLink: null,
                },
                {
                    title: 'AR Square',
                    desc: 
                        `AR application that detects surfaces and places an 
                        indicator at the center of where the phone camera 
                        looks and by touching the screen of the phone a 
                        3D red square will be placed - made for Android devices.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'ar-square',
                        totalImages: 1,   
                        downloadLink: null,
                },
                {
                    title: 'AR image tracking',
                    desc: 
                        `AR application that recognizes images and places a 3D object 
                        that tracks the position of the image - made for Android devices.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'ar-image-tracking',
                        totalImages: 1,   
                        downloadLink: null,
                },
            ]
        }
    }
}
</script>

<style>
/* Global CSS outside the scoped attribute */
:root {
  --ar-primary-color: #3bad2a;
  --ar-secondary-color: #1e4511;
}
</style>

<style scoped>
/* Scoped CSS for your component */
.container {
  color: white;
  margin-bottom: 50px;
  padding: 20px;
}

h1 {
  /*text-shadow: 0px 0px 2px crimson;*/
  margin-bottom: 40px;
  color: var(--ar-primary-color); /* Using the primary color variable */
}

p {
  margin-top: 5px;
  text-align: justify;
  font-size: 18px;
}

.animation {
  background-color: var(--ar-secondary-color); /* Using the secondary color variable */
  border: 1px solid var(--ar-primary-color); /* Using the primary color variable */
  border-radius: 4px;
  box-shadow: 0px 0px 5px var(--ar-primary-color); /* Using the primary color variable */
  padding: 1px;
  margin-bottom: 70px;
}

.desc {
  margin: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border: 2px solid var(--ar-primary-color); /* Using the primary color variable */
  border-radius: 4px;
}

.download-btn {
  background-color: var(--ar-primary-color); /* Using the primary color variable */
  border: 2px solid white;
  border-radius: 4px;
  box-shadow: 0px 0px 5px white;
  margin-bottom: 10px;
  color: white;
  font-size: 16px;
}

.download-btn:hover {
  background-color: white;
  color: var(--ar-primary-color); /* Using the primary color variable */
  border: 2px solid var(--ar-primary-color); /* Using the primary color variable */
}

@media screen and (min-width: 992px) {
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
}

section {
  /*background-color: #111845;*/
  min-height: 100vh;
}
</style>
